<app-header />
<div class="  bg_2">
    <div class="pr_detail_top bg_1 inline_padding1 p-top-132">
        <div class="pr_detail_top_flex dis-flex-7 ">
            <div class="text_blue_5 p-y-18 cursor-pointer" [routerLink]="['/']">
                <a>Home</a>
            </div>
            <div class="p-l-16 p-y-18">
                <svg width="7" height="8" viewBox="0 0 7 8" fill="none" xmlns="http://www.w3.org/2000/svg">
                    <path
                        d="M1.31367 7.85721L6.7222 4.44452C6.80933 4.38951 6.87927 4.32127 6.92722 4.24449C6.97517 4.1677 7 4.08419 7 3.99968C7 3.91517 6.97517 3.83165 6.92722 3.75487C6.87927 3.67809 6.80933 3.60985 6.7222 3.55484L1.31367 0.142143C0.797419 -0.18355 0 0.0864778 0 0.58698L0 7.41335C0 7.91386 0.797419 8.18388 1.31367 7.85721Z"
                        fill="#303030" />
                </svg>
            </div>
            <div class="text_blue_5 p-l-16 p-y-18 cursor-pointer" [routerLink]="['/profile']">
                <a>My Profile</a>
            </div>
            <div class="p-l-16 p-y-18">
                <svg width="7" height="8" viewBox="0 0 7 8" fill="none" xmlns="http://www.w3.org/2000/svg">
                    <path
                        d="M1.31367 7.85721L6.7222 4.44452C6.80933 4.38951 6.87927 4.32127 6.92722 4.24449C6.97517 4.1677 7 4.08419 7 3.99968C7 3.91517 6.97517 3.83165 6.92722 3.75487C6.87927 3.67809 6.80933 3.60985 6.7222 3.55484L1.31367 0.142143C0.797419 -0.18355 0 0.0864778 0 0.58698L0 7.41335C0 7.91386 0.797419 8.18388 1.31367 7.85721Z"
                        fill="#303030" />
                </svg>
            </div>
            <div class="text_black_8 p-l-16 p-y-18">
                <span>Settings</span>
            </div>
        </div>
    </div>
    <div class="pswd ">
       <!-- Success Alert -->
<div *ngIf="alertVisible" class="alert alert-success alert-dismissible fade show" role="alert">
    <strong>Success!</strong> Your password has been updated successfully.
    <button type="button" class="btn-close" (click)="closeAlert()"></button>
  </div>
  
        <div class="dis-grid-6 p-top-40 pswd_section">
            <div class=" width-100-per border_right_blue pswd_section_top">
                <div class="width-100-per">
                    <div class="cursor-pointer " [routerLink]="'/edit_profile'">
                        <div class="p-y-18">
                            <span class=" text_black_13">Edit Profile</span>
                        </div>
                    </div>
                    <div class="cursor-pointer right-border-3 m-r-3-neg">
                        <div class="p-y-18">
                            <span class="text_blue_17">Change Password</span>
                        </div>
                    </div>
                    <div data-bs-toggle="modal" data-bs-target="#signOutModal" class="cursor-pointer">
                        <div class="p-y-18">
                            <span class="text_black_13 ">Sign Out</span>
                        </div>
                    </div>
                </div>
            </div>
            <div class=" p-b-245 pswd_section_bottom">
                <form [formGroup]="pswdForm" (ngSubmit)="updatePassword()">
                    <div class="p-x-20 pswd_section_bottom_head">
                        <div class="width-100-per p-x-20 pswd_section_bottom_head_top">
                            <div class="bottom-border-1 pswd_section_bottom_head_top_section">
                                <div class="bottom-border-2 m-b-3">
                                    <span class="text_black_10">New Password</span>
                                </div>
                                <div class="p-bot-5 pswd_section_bottom_head_top_section_btn">
                                    <button type="submit" class="text_style_3 button_yellow_2">Update</button>
                                </div>
                            </div>
                        </div>
                        <div class="pswd_section_bottom_head_box">
                            <div class=" pswd_section_bottom_head_box_input1">
                                <div class="dis-block-1 p-top-18 p-x-20">
                                    <label for="oldPassword" class="dis-flex-4 text_grey_2">Old Password</label>
                                    <input type="password" id="oldPassword" formControlName="oldpassword"
                                        class="dis-flex-4 text_grey_3 height-40 border-radius-4 width-100-per p-x-15"
                                        placeholder="Enter Old Password" required>
                                </div>
                            </div>
                            <div class="dis-grid-2 pswd_section_bottom_head_box_input2">
                                <div class="dis-block-1 p-top-18 p-x-20">
                                    <label for="newPassword" class="dis-flex-4 text_grey_2">New Password</label>
                                    <input type="password" id="newPassword" formControlName="newpassword"
                                        class="dis-flex-4 text_grey_3 height-40 border-radius-4 width-100-per p-x-15"
                                        placeholder="Enter New Password" required>
                                </div>
                                <div class="dis-block-1 p-top-18 p-x-20">
                                    <label for="confirmPassword" class="dis-flex-4 text_grey_2">Confirm New
                                        Password</label>
                                    <input type="password" id="confirmPassword" formControlName="cpassword"
                                        class="dis-flex-4 text_grey_3 height-40 border-radius-4 width-100-per p-x-15"
                                        placeholder="Enter Confirm New Password" required>
                                </div>
                            </div>
                        </div>
                        <div class="p-x-20 pswd_section_bottom_head_btn">
                            <button type="submit" class="text_style_3 button_yellow_2">Update</button>
                        </div>
                    </div>

                </form>

            </div>
            <div class="pswd_section_signout modal fade bg_4" id="signOutModal" tabindex="-1"
                aria-labelledby="signOutModalLabel" aria-hidden="true">
                <div class="modal-dialog modal-dialog-centered custom-modal-dialog">
                    <div class="modal-content dis-flex-2 pswd_section_signout_screen">
                        <div class="bottom-border-1 width-100-per  pswd_section_signout_screen_top">
                            <div class="p-x-40 dis-flex-1 ">
                                <span class="text_blue_11">
                                    Sign Out
                                </span>
                            </div>
                        </div>
                        <div class="p-top-40 ">
                            <div class=" p-x-50">
                                <span class="text_style_1">Are you sure you want to sign out? Any unsaved
                                    changes
                                    will be lost.</span>
                            </div>
                        </div>
                        <div class=" pswd_section_signout_screen_btn">
                            <button class="text_blue_4 button_white_5 pswd_section_signout_screen_btn_box" (click)="LogoutClick()">Sign Out</button>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</div>
<app-footer />